.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

// Summary card mirrors design `igs05`: DAYS / PICKS sit on the left, a
// flex-grow spacer pushes EST. TOTAL to the right edge.
.stats-card {
  align-items: center;
  background: var(--color-surface-subtle, var(--color-surface));
  border: 1px solid var(--color-border-subtle, var(--color-border));
  border-radius: 8px;
  display: flex;
  gap: 16px;
  padding: 12px;
}

.stat-column {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stat-column-trailing {
  align-items: flex-end;
  margin-left: auto;
  text-align: right;
}

.day-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.day-card {
  background: var(--color-background);
  border: 1px solid var(--color-border-subtle, var(--color-border));
  border-radius: 8px;
  overflow: hidden;
}

.day-card-is-expanded {
  background: var(--color-background);
}

.day-header {
  align-items: center;
  background: var(--color-surface-subtle, var(--color-surface));
  border: 0;
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 10px;
  padding: 10px 14px;
  text-align: left;
  width: 100%;
}

// Day-1 (or the currently-focused day) lights up purple to anchor the
// reader; subsequent days are muted gray. Mirrors design tokens
// #A5B4FC (bg) / #312E81 (text).
.day-badge {
  align-items: center;
  background: var(--color-secondary);
  border-radius: 50%;
  color: var(--color-foreground);
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.day-badge-is-active {
  background: var(--color-badge-purple-bg);
  color: var(--color-badge-purple-fg);
}

.day-label {
  flex: 1 1 auto;
  min-width: 0;
}

.day-total {
  flex: 0 0 auto;
}

.chevron {
  align-items: center;
  color: var(--color-muted);
  display: inline-flex;
  flex: 0 0 auto;
}

.day-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 14px 12px;
}

.slot-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

// Three-column row mirrors design: time-badge | product-name | price.
// The badge has a fixed lane so prices align across rows.
.slot-row {
  align-items: center;
  display: flex;
  gap: 10px;
  padding: 4px 0;
}

.slot-time {
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
}

.slot-title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tip-row {
  align-items: center;
  display: flex;
  gap: 8px;
  padding: 4px 0;
}

.footer {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.footer-spacer {
  flex: 1 1 auto;
}
